import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { setToken } from "../lib/authApi";
import { useAuth } from "../auth/AuthProvider";

export default function DiscordCallback() {
    const [params] = useSearchParams();
    const nav = useNavigate();
    const { refresh } = useAuth();
    const [err, setErr] = useState("");

    useEffect(() => {
        async function finishLogin() {
            const token = params.get("token");

            if (!token) {
                setErr("Discord Login konnte nicht abgeschlossen werden.");
                return;
            }

            try {
                setToken(token);
                await refresh();
                nav("/manager", { replace: true });
            } catch (e) {
                setErr(e.message || "Login fehlgeschlagen.");
            }
        }

        finishLogin();
    }, [params, refresh, nav]);

    return (
        <div className="card">
            <h1>Discord Login</h1>

            {err ? (
                <div className="alert alert--error">{err}</div>
            ) : (
                <p>Login wird abgeschlossen...</p>
            )}
        </div>
    );
}